export type { ICatalogSource, ICatalogSourceCapability, IReferenceResponse } from '@infa-service/cdgc-catalog';
/**
 * Filters
 */

abstract class Filter<FilterConfig, FilterPayload> {
	public config!: FilterConfig;
	constructor(config: FilterConfig | FilterPayload) {
		if (config instanceof Array) {
			this.config = this.fromPayload(config as FilterPayload);
		} else {
			this.config = config as FilterConfig;
		}
	}

	public isEqual(filter: Filter<FilterConfig, FilterPayload>): boolean {
		return this.compare(this.config, filter.config);
	}

	abstract compare(a: FilterConfig, b: FilterConfig): boolean;
	abstract fromPayload(config: FilterPayload): FilterConfig;
	abstract toPayload(): FilterPayload;
}

/**
 * Metadata filter configuration.
 */
//@TODO:: updated based on possible values.
export type MetadataOptionChange = 'Retain' | 'Delete';
//@TODO:: updated based on possible values.
export type MetadataFilterType = 'Tables' | 'Views';
//@TODO:: updated based on possible values.
type FilterPivot = 'Include Metadata' | 'Exclude Metadata';
export type MetadataFilterConfig = {
	type: MetadataFilterType;
	pivot: FilterPivot;
	value: string;
};
export type MetadataFilterPayload = [
	{ key: 'Filter Pivot'; values: string[] },
	{ key: 'Filter Type'; values: string[] },
	{ key: 'Filter Value'; values: string[] },
];
export class MetadataFilter extends Filter<MetadataFilterConfig, MetadataFilterPayload> {
	fromPayload(config: MetadataFilterPayload) {
		return config.reduce((acc, eachConfig) => {
			if (eachConfig.key === 'Filter Pivot') {
				acc.pivot = eachConfig.values[0] as FilterPivot;
			} else if (eachConfig.key === 'Filter Type') {
				acc.type = eachConfig.values[0] as MetadataFilterType;
			} else if (eachConfig.key === 'Filter Value') {
				acc.value = eachConfig.values[0] as MetadataFilterType;
			}
			return acc;
		}, {} as MetadataFilterConfig);
	}
	compare(a: MetadataFilterConfig, b: MetadataFilterConfig): boolean {
		return a.pivot === b.pivot && a.type === b.type && a.value === b.value;
	}
	toPayload(): MetadataFilterPayload {
		return [
			{ key: 'Filter Pivot', values: [this.config.pivot] },
			{ key: 'Filter Type', values: [this.config.type] },
			{ key: 'Filter Value', values: [this.config.value] },
		];
	}
}

/**
 * Profiling filter configuration
 */
export type ProfilingFilterConfig = {
	type: MetadataFilterType;
	pivot: FilterPivot;
	conditions: 'Named';
	value: string;
};
export type ProfilingFilterPayload = [
	{
		key: 'Filter Pivot';
		values: string[];
	},
	{
		key: 'Filter Type';
		values: string[];
	},
	{
		key: 'Filter Conditions';
		values: string[];
	},
	{
		key: 'Filter Value';
		values: string[];
	},
];

export class ProfilingFilter extends Filter<ProfilingFilterConfig, ProfilingFilterPayload> {
	fromPayload(config: ProfilingFilterPayload) {
		return config.reduce((acc, eachConfig) => {
			if (eachConfig.key === 'Filter Pivot') {
				acc.pivot = eachConfig.values[0] as FilterPivot;
			} else if (eachConfig.key === 'Filter Type') {
				acc.type = eachConfig.values[0] as ProfilingFilterConfig['type'];
			} else if (eachConfig.key === 'Filter Conditions') {
				acc.conditions = eachConfig.values[0] as ProfilingFilterConfig['conditions'];
			} else if (eachConfig.key === 'Filter Value') {
				acc.value = eachConfig.values[0];
			}
			return acc;
		}, {} as ProfilingFilterConfig);
	}
	compare(a: ProfilingFilterConfig, b: ProfilingFilterConfig): boolean {
		return a.pivot === b.pivot && a.type === b.type && a.value === b.value && a.conditions === b.conditions;
	}
	toPayload(): ProfilingFilterPayload {
		return [
			{ key: 'Filter Pivot', values: [this.config.pivot] },
			{ key: 'Filter Type', values: [this.config.type] },
			{ key: 'Filter Conditions', values: [this.config.conditions] },
			{ key: 'Filter Value', values: [this.config.value] },
		];
	}
}
